import React, { useEffect, useState } from "react";
import {
  FaArrowLeft,
  FaFileInvoice,
  FaCheckCircle,
  FaGlobe,
} from "react-icons/fa";
import "../assets/css/InvoicesDetails.css";
import { useNavigate } from "react-router-dom";
import { getCompanyData } from "../Service/apiService";
let cachedStats = {
   total: 0,
    india: 0,
    foreign: 0,
};
const hasValidStats = (stats) => {
  return Object.values(stats).some(value => value > 0);
};

export default function InvoicesDetails() {
  const navigate = useNavigate();
const [stats, setStats] = useState(() => ({ ...cachedStats }));

  const isNotInternal = (c) => (c.companyType || "").toLowerCase() !== "internal";

   const [loading, setLoading] = useState(() => !hasValidStats(cachedStats));
 
   useEffect(() => {
     // Only fetch if we don't have valid cached data
     if (!hasValidStats(cachedStats)) {
       fetchInvoiceStats();
     }
   }, []);

  const fetchInvoiceStats = async () => {
     setLoading(true);
    try {
      const response = await getCompanyData("all"); // fetch all companies
      const companies = response?.data || [];

      // Filter non-internal companies with invoiceDate
      const invoicedCompanies = companies.filter(
        c => c.invoiceDate && isNotInternal(c)
      );

      const indiaCount = invoicedCompanies.filter(
        c => (c.country || "").toLowerCase() === "india"
      ).length;

      const foreignCount = invoicedCompanies.filter(
        c => (c.country || "").toLowerCase() !== "india"
      ).length;

     const computed = {
        total: invoicedCompanies.length,
        india: indiaCount,
        foreign: foreignCount,
      };
    setStats(computed);
    cachedStats = { ...computed };     
    } catch (err) {
      console.error("Error loading invoice stats:", err);
      setStats({ total: 0, india: 0, foreign: 0 });
    }
    finally {
      setLoading(false);
    }

  };

  const metrics = [
    {
      id: "total-invoices",
      key: "invoicedCompanies",
      label: "Total Invoices",
      value: stats.total,
      icon: FaFileInvoice,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "india-invoice",
      key: "indiainvoiceCompanies",
      label: "India Invoice",
      value: stats.india,
      icon: FaCheckCircle,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "foreign-invoice",
      key: "foreigninvoiceCompanies",
      label: "Foreign Invoice",
      value: stats.foreign,
      icon: FaGlobe,
      color: "rgb(5, 55, 99)",
    },
  ];



  const goToTable = (key) => {
    navigate(`/dashboard/companies/${key}`);
  };

    const NumberSkeleton = () => (
    <div className="number-skeleton">
      <div className="skeleton-loader"></div>
    </div>
  );


  return (
    <div className="invoice-details-container">
     

      <div className="metrics-grid">
        {metrics.map(({ id, label, value, icon: Icon, color, key }) => (
          <div key={id} className="metric-card" onClick={() => goToTable(key)}>
            <div className="metric-icon" style={{ background: color }}>
              <Icon size={18} />
            </div>
             <p className="metric-label">{label}</p>
            {loading ? (
              <NumberSkeleton />
            ) : (
              <p className="metric-value">{value}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}